// extracted by mini-css-extract-plugin
export default {"textLoop":"myStyles_textLoop__7Oq5B","discr":"myStyles_discr__nMp5o","btnLink":"myStyles_btnLink__luaKL","span":"myStyles_span__X0SAF"};